/**
 * =============================================================================
 * SPEQ55 RFP Pro - Cost Monitoring API Client
 * =============================================================================
 *
 * API client functions for cost monitoring and billing guardrails.
 *
 * @module api/costs
 * @author SPEQ55
 */

import api from './client.js';

/**
 * Get current month cost summary
 */
export async function getCostSummary() {
  const response = await api.get('/costs/summary');
  return response.data;
}

/**
 * Get daily cost breakdown
 */
export async function getDailyCostBreakdown(days = 30) {
  const response = await api.get(`/costs/daily?days=${days}`);
  return response.data;
}

/**
 * Get per-user cost breakdown
 */
export async function getUserCostBreakdown(startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);

  const response = await api.get(`/costs/users?${params.toString()}`);
  return response.data;
}

export default {
  getCostSummary,
  getDailyCostBreakdown,
  getUserCostBreakdown,
};
